import {
  faMegaphone,
  faChevronRight,
  faCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { HTMLAttributes } from 'react'
import { Link } from 'react-router-dom'
import { Popover } from '../../../../../components/Popover/Popover'
import { usePopper } from '../../../../../components/Popover/hooks/usePopper'
import { TruncatedText } from '../../../../../components/TruncatedText/TruncatedText'
import { ROUTES } from '../../../../../constants/routes'
import {
  ConfluenceContent,
  useFetchConfluenceContent,
} from '../../WhatsNewDetails/hooks/useFetchConfluenceContent'

export const WhatsNewButton = (props: HTMLAttributes<HTMLButtonElement>) => {
  const {
    data: content,
    lastViewedOn,
    setLastViewedOn,
  } = useFetchConfluenceContent({
    contentId: '131096',
  })
  const { target, toggle, targetProps, ...tooltipProps } = usePopper<HTMLButtonElement>({
    placement: 'bottom-end',
  })
  const hasUnseen =
    !lastViewedOn ||
    content?.children?.some(
      (c: ConfluenceContent) => c?.created && new Date(c?.created) > lastViewedOn,
    )
  return (
    <>
      <button
        {...props}
        {...targetProps}
        className={`btn border-0 ${tooltipProps.isOpen ? ' active' : ''}${
          props.className ? ` ${props.className}` : ''
        }`}
        ref={target}
        disabled={!content || undefined}
      >
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon icon={faMegaphone} transform="up-2" />
          {hasUnseen && (
            <FontAwesomeIcon
              icon={faCircle}
              className="text-danger"
              transform="shrink-8 right-8 down-8"
            />
          )}
        </span>
      </button>
      <Popover
        {...tooltipProps}
        toggle={() => {
          setLastViewedOn(new Date())
          toggle()
        }}
      >
        {content && (
          <>
            <h6
              className="dropdown-header"
              style={{
                '--bs-dropdown-header-padding-y': '1rem',
                '--bs-dropdown-header-padding-x': '1rem 0',
              }}
            >
              {content.title}
            </h6>
            <div style={{ maxHeight: '10.5rem', overflow: 'auto' }}>
              {content.children && content.children.length > 0 ? (
                content.children.map((child: ConfluenceContent) => (
                  <Link
                    className="dropdown-item border-bottom"
                    to={ROUTES.WHATS_NEW_DETAILS.replace(':id', child.id)}
                    key={`content-${child.id}`}
                  >
                    <h6>
                      {child.title}
                      {!!child.created &&
                        !!lastViewedOn &&
                        new Date(child.created) > lastViewedOn && (
                          <FontAwesomeIcon
                            icon={faCircle}
                            className="text-danger"
                            transform="shrink-8"
                          />
                        )}
                    </h6>
                    <TruncatedText className="text-body-secondary" lines={2}>
                      {child.summary}
                    </TruncatedText>
                  </Link>
                ))
              ) : (
                <div className="dropdown-item text-body-secondary d-flex">
                  <FontAwesomeIcon icon={faExclamationTriangle} size="2x" className="me-2" />
                  <div className="col text-wrap">There was an issue fetching articles.</div>
                </div>
              )}
            </div>
            <div className="dropdown-item border-top px-2 text-end">
              <Link
                className="btn btn-link btn-sm"
                to={ROUTES.WHATS_NEW_DETAILS.replace(':id', content.children?.[0].id || '')}
              >
                What's New
                <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
              </Link>
            </div>
          </>
        )}
      </Popover>
    </>
  )
}
